export default defineNuxtPlugin((nuxtApp) => {
    /*
    let isInitialized = false;

    const initContentsquare = () => {
        if (isInitialized || useRuntimeConfig().public.baseUrl.includes('localhost') || useRuntimeConfig().public.baseUrl.includes('dev')) {
            // return;
        }

        (function(c,s,o,n,t,u,a,r){
            c['CSObject']=t;
            c[t]=c[t]||function(){(c[t].q=c[t].q||[]).push(arguments)};
            u=s.createElement(o);u.async=1;u.src=n;
            a=s.getElementsByTagName(o)[0];a.parentNode.insertBefore(u,a);
        })(window, document, 'script', `https://t.contentsquare.net/uxa/${useRuntimeConfig().public.amplitudeID}.js`, 'CS');
    };

    const disableContentsquare = () => {
        if (isInitialized) {
            if (window.CSObject) {
                window.CSObject = function() { console.log('[Contentsquare] tracking disabled'); };
            }

            isInitialized = false;
        }
    };

    nuxtApp.hook('app:mounted', () => {
        const consentAnalytics = localStorage.getItem('silktideCookieChoice_performance') === 'true';

        if (consentAnalytics) {
            initContentsquare();
        }
    });

    window.addEventListener('consentPerformanceAccept', () => {
        initContentsquare();
    });

    window.addEventListener('consentPerformanceAccept', () => {
        disableContentsquare();
    });*/
});

